(function() {
    'use strict';

    angular
        .module('invesfleet')
        .directive('invesTabs', invesTabs);

    invesTabs.$inject = ['$window', '$rootScope'];
    
    function invesTabs($window, $rootScope) {
        // Usage:
        //     <tabsDirective></tabsDirective>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            templateUrl: 'app/views/directives/invesTabs.html',
            scope: {
                tabManager: '=tabManager'
            }
        };
        return directive;

        function link(scope, element, attrs) {


            var $activeTab = $('.nav-tabs li.active');
            $activeTab.addClass('measure');
            var width = $activeTab.width();
            $activeTab.removeClass('measure').css('min-width', width);

/*
            var STEP_SIZE = 7; //Pixels per frame

            var ul = element[0].getElementsByTagName('UL')[0];
            var lis = ul.getElementsByTagName('LI');
        
            var targetTab = 0; 
            var onTarget = true;
            var lastWidth = 0;
            var lastScrollWidth = 0;

            scope.overflow = false;

            //Functions
            scope.scrollTabs = scrollTabs;
            scope.goToTab = goToTab;
            scope.isArrowActive = isArrowActive;

            onframe();
        
            function onframe(){
                scope.overflow = ul.scrollWidth > ul.offsetWidth;
                if(ul.offsetWidth !== lastWidth){ lastWidth = ul.offsetWidth; reset(); }
                if(ul.scrollWidth !== lastScrollWidth){ lastScrollWidth = ul.scrollWidth; reset(); }
                takeStep();
                requestAnimationFrame(onframe);
            }

            function scrollTabs(dir){
                var maxScroll = ul.scrollWidth - ul.offsetWidth;

                if(dir === 'left' && targetTab > 0){
                    targetTab--;
                    onTarget = false;
                }else if (dir === 'right' && getOffset(targetTab) < maxScroll){
                    targetTab++;
                    onTarget = false;
                }
            }

            function takeStep(){
                if(onTarget){ return; }
                if(targetTab < 0 || targetTab >= lis.length){ reset(); return;}

                var maxScroll = ul.scrollWidth - ul.offsetWidth;
                var targetOffset = getOffset(targetTab);
                var sign = Math.sign(targetOffset - ul.scrollLeft);
                var step = sign * STEP_SIZE;

                if(ul.scrollLeft + step >= maxScroll){
                    ul.scrollLeft = maxScroll;
                    onTarget = true;
                }
                else if(ul.scrollLeft + step >= targetOffset && sign >= 0 || 
                        ul.scrollLeft + step <= targetOffset && sign < 0) {
                    ul.scrollLeft = targetOffset;
                    onTarget = true;
                }else{
                    ul.scrollLeft += step;
                }
            }

            function goToTab(tab){
                if(tab < 0 || tab >= lis.length){ return; }
                var maxScroll = ul.scrollWidth - ul.offsetWidth;
                if(getOffset(tab) > maxScroll){
                    targetTab = getMaxTab();
                    onTarget = false;
                }else{
                    targetTab = tab;
                    onTarget = false;
                }
            }

            function getMaxTab(){
                var maxScroll = ul.scrollWidth - ul.offsetWidth;
                var offset = 0;
                for (var i = 0; i < lis.length; i++) {
                    if(offset >= maxScroll){ return i; }
                    offset += lis[i].offsetWidth;
                }
            }

            function getOffset(tab){
                var offset = 0;
                for (var i = 0; i < lis.length; i++) {
                    if (i === tab) {return offset;}
                    offset += lis[i].offsetWidth;
                }
                return offset;
            }

            function reset(){
                targetTab = 0;
                onTarget = true;
                ul.scrollLeft = 0;
            }

            function isArrowActive(dir){
                if(dir === 'left'){
                    return targetTab > 0;
                }else if(dir === 'right'){
                    return targetTab < getMaxTab();
                }
            }

*/
        }
    }

})();